import React, { useContext } from "react";
import { translate } from "../../../utility/strings.js";

import { ShipmentContext } from "../../contexts/ShipmentContext.jsx";

const ShipmentTimelineItem = ({label, status, customIcon}) => <div className="shipment-timline__item text-center">
                                                      <div className={`shipment-timeline__item__icon shipment-timeline__item__icon--${status}`}>{customIcon}</div>
                                                      <br/>
                                                      <span class="font-bold">{label}</span>
                                                </div>

const ShipmentTimeline = () => {

  let { shipment, loading } = useContext(ShipmentContext);

  const statusKeys = Object.keys(window.theme.strings.shipment_tracking.status);
  console.log(shipment, loading)

  console.log(shipment?.summary?.status_key);

  if(!shipment?.summary?.status_key){
    return null;
  }

  let status = "completed";

  return (
    <div className="shipment-timline container container--narrow my-10 flex gap-5">
      {loading || !shipment ? 
        <div>Loading...</div> 
      : 
        statusKeys.map((key) => {
          let customIcon = null;
          if(status === "active") status = "pending";
          if(key == shipment?.summary?.status_key) status = "active";
          if(key === "delivered" && status == "active"){
            status = "custom";
            customIcon = <span class="custom-icon custom-icon--emoji">&#129311;</span>
          };
          return <ShipmentTimelineItem label={window.theme.strings.shipment_tracking.status[key]} status={status} customIcon={customIcon}/>
        })
      }
    </div>
  );

}

export default ShipmentTimeline;
